export default __webpack_public_path__ + "static/media/Commercial.5d807dee.svg";